/**
 * Registration Page
 *
 * Page component that wraps the RegisterForm.
 * Layout (header, footer, centering) is handled by AuthLayout.
 */

import { RegisterForm } from "../../components/auth";

interface RegisterPageProps {
  onSuccess?: () => void;
}

export function RegisterPage({ onSuccess }: RegisterPageProps) {
  const handleSuccess = (_data: { userId: string; tenantId: string }) => {
    onSuccess?.();
  };

  return (
    <RegisterForm
      onSuccess={handleSuccess}
      apiBaseUrl={import.meta.env.VITE_API_BASE_URL || "http://localhost:8787"}
    />
  );
}
